export default __webpack_public_path__ + "1cce9e87bb8240e800170c0d2d45a00d.png";